import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { BatchRequestsService } from './api/batchRequests.service';
import { YpmDocumentVService } from './api/ypmDocumentV.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class DocumentApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<DocumentApiModule> {
        return {
            ngModule: DocumentApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: DocumentApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('DocumentApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
